import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';
import secureFetch from 'shared/lib/secure-fetch';
import { AuthContext } from './AuthProvider';

export const ConfigContext = createContext({});

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 */
// Client reads config values with an API request.
// See server/config.go for more information.
export default function ConfigProvider({ children }) {
  const { getAccessToken, isLoggedIn } = useContext(AuthContext);
  const [state, setState] = useState({});

  useEffect(() => {
    (async () => {
      if (!isLoggedIn) return;
      try {
        const accessToken = await getAccessToken();
        if (accessToken) setState(await secureFetch('config', accessToken));
      } catch (error) {
        console.error(`failed to fetch config: ${error}`);
      }
    })();
  }, [getAccessToken, isLoggedIn]);

  return <ConfigContext.Provider value={state}>{children}</ConfigContext.Provider>;
}
